import type { AreaRoute } from "./areaRoute";
import { lazyPage } from "../../lib/lazyPage";

export const UsersRolesPage = lazyPage(() => import("../access/UsersRolesPage"), "UsersRolesPage");
export const AccessReviewPage = lazyPage(() => import("../access/AccessReviewPage"), "AccessReviewPage");
export const RequestAccessPage = lazyPage(() => import("../access/RequestAccessPage"), "RequestAccessPage");

export const accessRoutes: AreaRoute[] = [];
